import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { StripepayPage } from './stripepay.page';

const routes: Routes = [
  {
    path: '',
    component: StripepayPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class StripepayPageRoutingModule {}
